
<div class="mb-dialog-provider-info">
  <mb-dialog-body>
    <h4>Provider Info</h4>
    <h6>Nombre: <span>{{ dialogData.cluster?.rates[0].provider }}</span></h6>
    <h6>
      Margen:  <span> {{ dialogData.currencyCode }}
     {{ dialogData.cluster?.rates[0].price.commission.value | Currency }}</span>
    </h6>
    <h6>Costo: <span>{{ dialogData.currencyCode }} {{ dialogData.finalCost | Currency }}</span></h6>
    @if (dialogData.rateInfo.dynamicPrice) {
      <h6>Pricing Dinámico: <span>Aplicado</span></h6>
      <h6>Proveedor Neto: <span>{{ dialogData.rateInfo.dynamicPrice.target_rate_provider }}</span></h6>
      <h6>
        Markup Dinámico: <span>{{ dialogData.rateInfo.dynamicPrice.target_rate_commission }}</span>
      </h6>
    } @else {
      <h6>Pricing Dinámico: <span>No aplicado</span></h6>
    }
    <h6>
      Polcom:
      <a
        href="{{ urlPolcom }}/hotels/polcom-v2/pricing/current/detail/{{
          dialogData.rateInfo.polcomId
        }}"
        target="_blank"
        >Política de compra aplicada</a
      >
    </h6>
  </mb-dialog-body>
  <mb-dialog-footer>
    <button mb-button variant="floating" color="secondary" (click)="dialogRef.close()">
      Cerrar
    </button>
  </mb-dialog-footer>
</div>
